import { useEffect, useState } from 'react'
import { ArrowUpDown, ChevronDown, ChevronUp } from 'lucide-react'
import Button from '../../components/Button'
import IconButton from '../../components/IconButton'
import Modal from '../../components/Modal'
import { strings as S } from './strings'
import './ProgramOrderModal.css'

const O = S.ordering

/**
 * ترتيب البرامج التدريبية — `_ProgramManagement_Ordering_Modal.cshtml`.
 *
 * The order the learner's panel lists programmes in. The button that opens this has been
 * on the page since it was built and had no handler; `SaveProgramsOrder` has been there
 * the whole time.
 *
 * MOVED WITH BUTTONS, NOT DRAGGED. The legacy uses a jQuery drag handle, and a drag-and-drop
 * list is the one control that is unusable by keyboard, unreliable on a touch screen and
 * awkward in RTL — three problems for a list that is reordered once. Up and down do the
 * same job, say which item they are about, and need no library.
 *
 * The order is only sent when SAVE is pressed. Reordering in place and posting each move
 * would write a half-finished order every time a row passed another.
 */
export default function ProgramOrderModal({ open, programs, onClose, onSubmit, saving }) {
  const [items, setItems] = useState([])

  // Reopened: start from the stored order again, not from an abandoned edit.
  useEffect(() => {
    if (open) setItems(programs ?? [])
  }, [open, programs])

  const move = (index, delta) => {
    const target = index + delta
    if (target < 0 || target >= items.length) return

    setItems((previous) => {
      const next = [...previous]
      ;[next[index], next[target]] = [next[target], next[index]]
      return next
    })
  }

  return (
    <Modal
      open={open}
      size="sm"
      title={O.title}
      icon={ArrowUpDown}
      hint={O.hint}
      onClose={onClose}
      footer={
        <Button disabled={saving} onClick={() => onSubmit(items.map((item) => item.id))}>
          {saving ? O.saving : O.save}
        </Button>
      }
    >
      <ol className="progorder">
        {items.map((item, index) => (
          <li key={item.id} className="progorder__row">
            {/* The position, which is the whole point of the list — without it the
                reader has to count rows to know what they are changing. */}
            <span className="progorder__rank">{index + 1}</span>
            <bdi className="progorder__name">{item.name}</bdi>
            <span className="progorder__moves">
              <IconButton
                icon={ChevronUp}
                size="sm"
                label={`${O.moveUp}: ${item.name}`}
                disabled={index === 0}
                onClick={() => move(index, -1)}
              />
              <IconButton
                icon={ChevronDown}
                size="sm"
                label={`${O.moveDown}: ${item.name}`}
                disabled={index === items.length - 1}
                onClick={() => move(index, 1)}
              />
            </span>
          </li>
        ))}
      </ol>
    </Modal>
  )
}
